define('ctrl/member/member-registration-verification',['require','ns','ctrl/base'],function (require) {
    'use strict';

    var ns = require('ns');

    var BaseController = require('ctrl/base');

    var _selector = {
        memberEmail: '#member_email',
        resendEmailBtn: '#resend-email-btn',
        resendEmailMsg: '#resend-email-result-msg',
        redirectBtn: '#redirect-btn'
    };

    var $selector = {};

    var MemberRegistrationVerificationController = BaseController.extend({

        init: function () {
            BaseController.prototype.init.call(this);

            $selector = ns.utils.generateSelector(_selector);

            this._registerEvent();
        },

        getUriSegment: function (i) {
            var segment =  window.location.pathname.substring(1).split('/');
            return segment[i];
        },

        _registerEvent: function () {

            var _localeCode = this.getUriSegment(0);

            $(_selector.resendEmailBtn).click(function() {
                var param = {
                    localeCode: _localeCode,
                    email: $selector.memberEmail.val()
                };
                var successCallback = function(data) {
                    $selector.resendEmailBtn.hide();
                    $selector.resendEmailMsg.text(ns.resources[_localeCode].resendVerificationEmailSuccess);
                };
                var errorCallback = function(data) {
                    $selector.resendEmailBtn.hide();
                    $selector.resendEmailMsg.text(data.message);
                };
                ns.api.member.resendVerificationEmail(param, successCallback, errorCallback);
            });
            
            $(_selector.redirectBtn).click(function() {
                var $self = $(this);
                var url = $self.attr("data-url");
                var fallback = $self.attr("data-fallback");
                if (!_.isNull(fallback) && !_.isEmpty(fallback) && !_.isUndefined(fallback)) {
                    setTimeout(function () {
                        window.location = fallback;
                    }, 250);
                }
                window.location = url;
            });
        }
    });

    return MemberRegistrationVerificationController;
});
